import { useState, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { fmt } from './utils';

export const InlineEdit = ({ value, onChange, type = 'text', placeholder = '', readOnly, className = '', isCurrency = false }) => {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(value ?? '');
  const ref = useRef(null);

  const save = () => {
    setEditing(false);
    if (isCurrency) {
      const num = parseFloat(val);
      onChange(isNaN(num) ? null : num);
    } else {
      onChange(val);
    }
  };

  const handleClick = () => {
    if (readOnly) return;
    setVal(value ?? '');
    setEditing(true);
    setTimeout(() => ref.current?.focus(), 0);
  };

  if (editing) {
    return (
      <Input
        ref={ref}
        value={val}
        onChange={e => setVal(e.target.value)}
        onBlur={save}
        onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setEditing(false); }}
        type={isCurrency ? 'number' : type}
        step={isCurrency ? '0.01' : undefined}
        className={`h-7 text-xs px-1.5 ${className}`}
        data-testid="inline-edit-input"
      />
    );
  }

  const display = isCurrency ? fmt(value) : (value || '');

  return (
    <span
      onClick={handleClick}
      className={`block min-h-[28px] px-1.5 py-1 text-xs rounded cursor-pointer hover:bg-[#2d948c]/5 transition-colors truncate ${!display ? 'text-[#5b6773]/40 italic' : ''} ${isCurrency ? 'tabular-nums text-right' : ''} ${className}`}
      title={display || placeholder}
    >
      {display || placeholder}
    </span>
  );
};
